import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** The statuses at which a Standard order's pick can be open on either path: Accepted on the manual path, Delivery Scheduling on the auto path. */
export const SALES_ORDER_PICKING_STATUS_IDS = [
    SalesOrderStatus.ACCEPTED,
    SalesOrderStatus.DELIVERY_SCHEDULING,
];
//# sourceMappingURL=sales-order-picking-status-ids.js.map